var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.newCelusVersion)?_c('v-app',[_c('NewCelusVersionDialog')],1):(_vm.$route.meta.outsideNormalLayout)?_c('router-view'):(_vm.invalidUser)?_c('InvalidUserPage'):(
    _vm.user &&
    !_vm.user.impersonator &&
    !_vm.emailVerified &&
    (!_vm.user.is_superuser || _vm.otpRequired)
  )?_c('EmailNotVerified'):(_vm.bootUpFinished)?_c('StandardLayout'):_c('div',[_c('v-app',[_c('BootUpWidget'),(_vm.showLoginDialog)?_c('LoginDialog'):(_vm.otpRequired)?_c('OtpDialog'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }